<template>
    <div>
        <component-header
            title="Update Kyc"
            :hasSearch="false"
            :hasReload="false"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.push('/user')"
        />
        <b-card>
            <s-kyc
                class="mt-2"
                ref="kycForm"
                @readKYC="KYCUpdate($event)"
                :kycData="documentList"
                :userID="currentUser._id"
            >
                <template v-slot:footer-button="data">
                    <b-row class="mt-3 justify-content-center">
                        <b-col md="2">
                            <b-button
                                class="btn btn-block"
                                btn-color="primary"
                                :disabled="
                                    !kycChangeObj.addressProofBack ||
                                    !kycChangeObj.addressProofFront ||
                                    !kycChangeObj.photoIdFront ||
                                    !kycChangeObj.photoIdBack ||
                                    !kycChangeObj.idproofNo ||
                                    !kycChangeObj.addressproofNo
                                "
                                @click="AgreeToNext(data.data)"
                                >Update KYC</b-button
                            >
                        </b-col>
                    </b-row>
                </template>
            </s-kyc>
        </b-card>
    </div>
</template>

<script>
import sKYC from "@/components/User/KYC_v2.vue";
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "UpdateKyc",
    components: {
        "s-kyc": sKYC,
        ComponentHeader,
    },
    data() {
        return {
            currentUser: null,
            kycChangeObj: {},
            documentList: null,
        };
    },
    methods: {
        async AgreeToNext(item) {
            console.log(item, "item");

            if (this.$route.query.mode === "update") {
                let payload = {
                    userId: this.currentUser?._id,
                    document: [
                        {
                            category: "ID_PROOF",
                            docType: "ID_PROOF",
                            docuementNo: "46745658756",
                            frontSideFilePath:
                                "https://nipigedev-storage.s3.amazonaws.com/images/kyc/agent/mev3wt66c17gf",
                            backSideFilePath:
                                "https://nipigedev-storage.s3.amazonaws.com/images/kyc/agent/mev3wvn4f2x5v",
                            remarks: [],
                        },
                        {
                            category: "ADDRESS_PROOF",
                            docType: "ADDRESS_PROOF",
                            docuementNo: "6785678567",
                            frontSideFilePath:
                                "https://nipigedev-storage.s3.amazonaws.com/images/kyc/agent/mev3wykd4ssm0",
                            backSideFilePath:
                                "https://nipigedev-storage.s3.amazonaws.com/images/kyc/agent/mev3x1d06bwwt",
                            remarks: [],
                        },
                    ],
                };
                // await this.$store.dispatch("tenant/updateKycData", payload);

                this.$swal({
                    title: "Success",
                    text: "Kyc Updated Successfully!",
                    type: "success",
                });
                this.$router.push({ path: "/user" });
            } else {
                this.$refs.kycForm
                    .submitKyc(this.currentUser._id)
                    .then((result) => {
                        this.$router.push({ path: "/user" });
                    })
                    .catch((error) => {});
            }
        },
        KYCUpdate(event) {
            console.log(event, "KYCUpdate");
            this.kycChangeObj = event;
        },
    },
    mounted() {
        this.currentUser = this.$route.params.userData;
        const idData = this.$route.params.kycData;
        if (Array.isArray(idData)) {
            console.log(idData, "idData");
            const idProof = idData.find((x) => x.category === "ID_PROOF");
            const addProof = idData.find((x) => x.category === "ADDRESS_PROOF");
            this.documentList = {
                addressProofFront: addProof.frontSideFilePath,
                addressProofBack: addProof.backSideFilePath,
                photoIdFront: idProof.frontSideFilePath,
                photoIdBack: idProof.backSideFilePath,
                idproofNo: idProof.docuementNo,
                addressproofNo: addProof.docuementNo,
            };
        }
    },
};
</script>
